import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useContext, useState } from 'react';
import IconButton from '../../legacy/IconButton/IconButton';
import { DropdownStateContext } from '../../DropdownStateManager';
import { PopperDropdownManager, PopperDropdownContent } from '../../PopperDropdownLayout';
import { setRefs } from '../../../../utils/refHelpers';
/*
  Separate content component so we can make use of the DropdownStateContext provided
  by PopperDropdownManager without needing to use a child render function with DropdownStateContext.Consumer.

  Saves some renders.
*/ const Content = (_param)=>{
    var { innerRef, className, biData, onOpenBiData = biData, onCloseBiData = biData, children, placement, popoverRole, popoverOffset, popoverAriaLabel, popoverChildren } = _param, rest = _object_without_properties(_param, [
        "innerRef",
        "className",
        "biData",
        "onOpenBiData",
        "onCloseBiData",
        "children",
        "placement",
        "popoverRole",
        "popoverOffset",
        "popoverAriaLabel",
        "popoverChildren"
    ]);
    const [referenceElement, setReferenceElement] = useState(null);
    const { setToggleRef, isOpen } = useContext(DropdownStateContext);
    const refCallback = useCallback((node)=>setRefs([
            setToggleRef,
            setReferenceElement,
            innerRef
        ], node), [
        setToggleRef,
        innerRef
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButton, _object_spread({
        "aria-haspopup": true,
        "aria-expanded": isOpen,
        className: className,
        innerRef: refCallback,
        biData: isOpen ? onCloseBiData : onOpenBiData
    }, rest), children), /*#__PURE__*/ React.createElement(PopperDropdownContent, {
        placement: placement,
        usePortal: true,
        role: popoverRole,
        "aria-label": popoverAriaLabel,
        referenceElement: referenceElement,
        offsetModifier: popoverOffset
    }, popoverChildren));
};
export const IconButtonWithPopover = (_param)=>{
    var { isInPopup } = _param, rest = _object_without_properties(_param, [
        "isInPopup"
    ]);
    return /*#__PURE__*/ React.createElement(PopperDropdownManager, {
        isInPopup: isInPopup
    }, /*#__PURE__*/ React.createElement(Content, rest));
};
IconButtonWithPopover.displayName = 'IconButtonWithPopover';
export default IconButtonWithPopover;

//# sourceMappingURL=IconButtonWithPopover.js.map